import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Prefissi internazionali (default Italia +39)
export const COUNTRY_CODES = [
  { cc: "+39", flag: "\uD83C\uDDEE\uD83C\uDDF9", label: "Italia" },
  { cc: "+41", flag: "\uD83C\uDDE8\uD83C\uDDED", label: "Svizzera" },
  { cc: "+33", flag: "\uD83C\uDDEB\uD83C\uDDF7", label: "Francia" },
  { cc: "+49", flag: "\uD83C\uDDE9\uD83C\uDDEA", label: "Germania" },
  { cc: "+44", flag: "\uD83C\uDDEC\uD83C\uDDE7", label: "Regno Unito" },
  { cc: "+34", flag: "\uD83C\uDDEA\uD83C\uDDF8", label: "Spagna" },
  { cc: "+1", flag: "\uD83C\uDDFA\uD83C\uDDF8", label: "USA/Canada" },
];

// Scompone un numero salvato in { cc, local }. Mantiene il numero esistente,
// riconoscendo il prefisso internazionale se presente.
export function splitPhone(value) {
  const raw = (value || "").trim();
  if (!raw) return { cc: null, local: "" };
  if (raw.startsWith("+")) {
    const digits = raw.replace(/[^\d]/g, "");
    const found = COUNTRY_CODES.find((c) => digits.startsWith(c.cc.slice(1)));
    if (found) return { cc: found.cc, local: digits.slice(found.cc.length - 1) };
    return { cc: null, local: digits };
  }
  let d = raw.replace(/[^\d]/g, "");
  if (d.startsWith("00")) {
    d = d.slice(2);
    const f = COUNTRY_CODES.find((c) => d.startsWith(c.cc.slice(1)));
    if (f) return { cc: f.cc, local: d.slice(f.cc.length - 1) };
  }
  return { cc: null, local: d };
}

export const combinePhone = (cc, local) => {
  const d = (local || "").replace(/[^\d]/g, "");
  return d ? `${cc}${d}` : "";
};

/**
 * Campo telefono con selettore prefisso + numero.
 * - value: numero salvato (formato internazionale, es. +393331234567) o vuoto
 * - onChange(nextValue): riceve il numero ricomposto in formato internazionale
 */
export function PhoneField({ value, onChange, testid, disabled, placeholder = "333 1234567", className = "" }) {
  const parsed = splitPhone(value);
  const [cc, setCc] = useState(parsed.cc || "+39");
  useEffect(() => { if (parsed.cc && parsed.cc !== cc) setCc(parsed.cc); }, [parsed.cc]); // sync su caricamenti async
  const local = parsed.local;
  return (
    <div className={`flex gap-2 ${className}`}>
      <Select value={cc} onValueChange={(v) => { setCc(v); onChange(combinePhone(v, local)); }} disabled={disabled}>
        <SelectTrigger className="w-[116px] shrink-0" data-testid={testid ? `${testid}-cc` : undefined}><SelectValue /></SelectTrigger>
        <SelectContent>
          {COUNTRY_CODES.map((c) => <SelectItem key={c.cc} value={c.cc}>{c.flag} {c.cc}</SelectItem>)}
        </SelectContent>
      </Select>
      <Input value={local} inputMode="tel" placeholder={placeholder} className="flex-1" disabled={disabled}
        data-testid={testid} onChange={(e) => onChange(combinePhone(cc, e.target.value))} />
    </div>
  );
}
